import axios from 'axios';
// axios.defaults.withCredentials=true;
import Qs from 'qs'
// http请求


function apiAxios(method, url, params, response,stuts) {
  if (stuts==1){
    var http = axios.create({
      baseURL: '/',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      transformRequest: [function (data) {
        // 对 data 进行任意转换处理
        // data = Qs.stringify(data);
        data = JSON.stringify(data);
        return data;
      }],
    });
  } else if(stuts==2){
    var info= localStorage.getItem('userInfoData');
    if (info){
      var user= JSON.parse(info);
      var token=user.token;
    };
    var http = axios.create({
      baseURL: '/',
      withCredentials: true,
      'responseType': 'blob',
      headers: {
        "Accept": "application/octet-stream",
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
      },
      transformRequest: [function (data) {
        // 对 data 进行任意转换处理
        // data = Qs.stringify(data);
        data = JSON.stringify(data);
        return data;
      }],
    });
  }else {
    var info= localStorage.getItem('userInfoData');
    if (info){
      var user= JSON.parse(info);
      var token=user.token;
    };
    var http = axios.create({
      baseURL: 'http://localhost:8081/',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Authorization': 'Bearer '+token,
      },
      transformRequest: [function (data) {
        // 对 data 进行任意转换处理
        // data = Qs.stringify(data);
        data = JSON.stringify(data);
        return data;
      }],
    });
  }
  http({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
  }).then(function (res) {
    if (res.status >= 200 && res.status < 300) {
      if (res.data.code=='10000') {
        var test = window.location.pathname;
        if (test!=='/login') {
          localStorage.removeItem('userInfoData');
          location.href = '/login'
        }
      }
      response(res.data);
    }
  }).catch(function (err) {
    console.error(err);
  })
}

export default {
  axiosFun: function (api, params, response,stuts) {
    return apiAxios(api['method'], api['url'], params, response,stuts);
  }
}



// WEBPACK FOOTER //
// ./src/common/http.js